import { ITongHopToanKhoaRequest } from "../../model/request/tong-hop-diem/ITongHopToanKhoaRequest";
import { apiClient } from "../apiClient";

export const TONG_HOP_TOAN_KHOA_ENDPOINT = "diem/tong-hop-toan-khoa";
export const tongHopToanKhoaApi = {
    Select: (request: ITongHopToanKhoaRequest) => apiClient.post(`${TONG_HOP_TOAN_KHOA_ENDPOINT}`, request),
}